<template>
  <div class="game-feedback feedback" :data-mood="mood">
    <div class="feedback__face"></div>
  </div>
</template>

<script>
export default {
  name: 'GameFeedback',

  props: {
    mood: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.feedback {
  position: absolute;
  top: calc(var(--unit-vw) * 2);
  right: calc(var(--unit-vw) * 0.3);
  width: calc(162px * var(--rw));
  height: calc(162px * var(--rw));

  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;

  transform: scale(0);

  @include mq($until: ipadP) {
    top: var(--unit-vw);
    width: calc(140px * var(--rw));
    height: calc(140px * var(--rw));
  }

  &__face {
    width: calc(54px * var(--rw));
    height: calc(54px * var(--rw));

    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;

    @include mq($until: ipadP) {
      width: calc(46px * var(--rw));
      height: calc(46px * var(--rw));
    }
  }

  &[data-mood="happy"] {
    background-image: url('/img/svg/happy-background.svg');

    .feedback__face {
      background-image: url('/img/svg/happy-face.svg');
    }
  }

  &[data-mood="sad"] {
    background-image: url('/img/svg/sad-background.svg');

    .feedback__face {
      background-image: url('/img/svg/sad-face.svg');
    }
  }
}
</style>
